import api from '../../../services/api';
import endPoints from '../../../services/endPoints';
import { types } from '../../types/types';
import { hideTableLoaderAction, showTableLoaderAction } from '../loaderAction';
import { showToast } from '../toastAction';

const getReports = () => async (dispatch, getState) => {
    const state = getState();
    let reports = state.moreReport.reports;
    if (!reports?.length) {
        dispatch(showTableLoaderAction());
    }
    const res = await api('get', endPoints.REPORT);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.CHANGE_REPORT,
                payload: res.data,
            });
        }
    } else {
        dispatch(showToast({ severity: 'error', summary: res.message ?? res }));
    }
    dispatch(hideTableLoaderAction());
};

const getReport = (id, returnData) => async (dispatch) => {
    const res = await api('get', endPoints.REPORT + id);
    if (res.success) {
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    } else {
        dispatch(showToast({ severity: 'error', summary: res.message ?? res }));
    }
};

const addReport = (data, setLoading, history) => async (dispatch) => {
    setLoading(true);
    const res = await api('post', endPoints.REPORT, data);
    if (res.success) {
        history.goBack();
    }
    setLoading(false);
};

const editReport = (id, data, setLoading, next) => async (dispatch, getState) => {
    setLoading(true);
    const res = await api('put', endPoints.REPORT + id, data);
    if (res.success) {
        next(res.data);
    }
    setLoading(false);
};

const deleteReport = (id) => async (dispatch) => {
    const res = await api('delete', endPoints.REPORT + id);
    if (res.success) {
        dispatch(getReports(() => {}));
        dispatch(showToast({ severity: 'success', summary: res.message }));
    } else {
        dispatch(showToast({ severity: 'error', summary: res.message }));
    }
};

const getReportFilters = (data, next) => async (dispatch, getState) => {
    const res = await api('get', endPoints.REPORT + `filter/inventory`, {}, data);
    if (res.success) {
        next(res.data);
    } else {
        dispatch(showToast({ severity: 'error', summary: res.message ?? res }));
    }
    dispatch(hideTableLoaderAction());
};
const getGeneratedReport = (id, setReportLoading, next) => async (dispatch) => {
    setReportLoading(true);
    const res = await api('get', endPoints.REPORT + `generate-report/${id}`);
    if (res.success) {
        next(res.data);
    } else {
        dispatch(showToast({ severity: 'error', summary: res.message ?? res }));
    }
    setReportLoading(false);
};

export { getReports, addReport, deleteReport, getReport, editReport, getReportFilters, getGeneratedReport };
